enum OpenLink {
  SAME_WINDOW = '1',
  NEW_WINDOW = '2',
}

export { OpenLink };
